var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpcomingPayoutsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.4771,
    r: 30,
    fill: "#ECF1F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.332 44.8548H21.6654C16.6654 44.8548 13.332 42.3548 13.332 36.5215V24.8548C13.332 19.0215 16.6654 16.5215 21.6654 16.5215H38.332C43.332 16.5215 46.6654 19.0215 46.6654 24.8548V36.5215C46.6654 42.3548 43.332 44.8548 38.332 44.8548Z",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 25.6878H14.9987C19.9987 25.6878 21.6654 24.0212 21.6654 19.0212V17.3545",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6654 25.6878H44.9987C39.9987 25.6878 38.332 24.0212 38.332 19.0212V17.3545",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 35.688H14.9987C19.9987 35.688 21.6654 37.3547 21.6654 42.3547V44.0213",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6654 35.688H44.9987C39.9987 35.688 38.332 37.3547 38.332 42.3547V44.0213",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.35 28.838L29.85 31.338C30.05 31.538 30.05 31.838 29.85 32.038L27.35 34.538C27.25 34.638 27.15 34.688 27 34.688C26.85 34.688 26.75 34.638 26.65 34.538C26.45 34.338 26.45 34.038 26.65 33.838L28.8 31.688L26.65 29.538C26.45 29.338 26.45 29.038 26.65 28.838C26.85 28.638 27.15 28.638 27.35 28.838ZM30.85 34.538L33.35 32.038C33.55 31.838 33.55 31.538 33.35 31.338L30.85 28.838C30.65 28.638 30.35 28.638 30.15 28.838C29.95 29.038 29.95 29.338 30.15 29.538L32.3 31.688L30.15 33.838C29.95 34.038 29.95 34.338 30.15 34.538C30.25 34.638 30.35 34.688 30.5 34.688C30.65 34.688 30.75 34.638 30.85 34.538Z",
    fill: "#4F4F4F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24681_29915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 28,
    width: 8,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.35 28.838L29.85 31.338C30.05 31.538 30.05 31.838 29.85 32.038L27.35 34.538C27.25 34.638 27.15 34.688 27 34.688C26.85 34.688 26.75 34.638 26.65 34.538C26.45 34.338 26.45 34.038 26.65 33.838L28.8 31.688L26.65 29.538C26.45 29.338 26.45 29.038 26.65 28.838C26.85 28.638 27.15 28.638 27.35 28.838ZM30.85 34.538L33.35 32.038C33.55 31.838 33.55 31.538 33.35 31.338L30.85 28.838C30.65 28.638 30.35 28.638 30.15 28.838C29.95 29.038 29.95 29.338 30.15 29.538L32.3 31.688L30.15 33.838C29.95 34.038 29.95 34.338 30.15 34.538C30.25 34.638 30.35 34.688 30.5 34.688C30.65 34.688 30.75 34.638 30.85 34.538Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24681_29915)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 25.688H36V37.688H24V25.688Z",
    fill: "#4F4F4F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingPayoutsIcon);
export default __webpack_public_path__ + "static/media/UpcomingPayoutsIcon.e57d172974e7ca20d15b92a1e34302ad.svg";
export { ForwardRef as ReactComponent };